const EmployeeData = [
    {
        id: 1,
        fullname: "Luther Julien",
        position: "Customer Support",
        office: "New York",
        age: 37,
        start_date: "10/6/2023",
        salary: 203734,
    },
    {
        id: 2,
        fullname: "Hurlee Blondelle",
        position: "Team Leader",
        office: "New York",
        age: 27,
        start_date: "2/8/2023",
        salary: 772542,
    },
    {
        id: 3,
        fullname: "Adriane Oldis",
        position: "Development Lead",
        office: "New York",
        age: 35,
        start_date: "1/7/2023",
        salary: 870444,
    },
    {
        id: 4,
        fullname: "Aymer Klimsch",
        position: "Office Manager",
        office: "Singapore",
        age: 31,
        start_date: "12/12/2022",
        salary: 829581,
    },
    {
        id: 5,
        fullname: "Courtney Aaron",
        position: "Developer",
        office: "Tokyo",
        age: 36,
        start_date: "6/5/2022",
        salary: 566074,
    },
    {
        id: 6,
        fullname: "Towny Scarr",
        position: "Office Manager",
        office: "Sydney",
        age: 23,
        start_date: "4/3/2023",
        salary: 265721,
    },
    {
        id: 7,
        fullname: "Carrol Egentan",
        position: "Developer",
        office: "Sydney",
        age: 30,
        start_date: "7/11/2022",
        salary: 894524,
    },
    {
        id: 8,
        fullname: "Dannye Renals",
        position: "Marketing Designer",
        office: "San Francisco",
        age: 34,
        start_date: "2/18/2022",
        salary: 1102407,
    },
    {
        id: 9,
        fullname: "Sarine Roughley",
        position: "Javascript Developer",
        office: "Tokyo",
        age: 33,
        start_date: "11/18/2022",
        salary: 717507,
    },
    {
        id: 10,
        fullname: "Wiley Blunderfield",
        position: "Customer Support",
        office: "Sydney",
        age: 28,
        start_date: "9/15/2022",
        salary: 502376,
    },
    {
        id: 11,
        fullname: "Rafaello Traylen",
        position: "Chief Executive Officer (CEO)",
        office: "New York",
        age: 29,
        start_date: "8/22/2022",
        salary: 457063,
    },
    {
        id: 12,
        fullname: "Dasya Real",
        position: "Customer Support",
        office: "Edinburgh",
        age: 45,
        start_date: "8/25/2022",
        salary: 266329,
    },
    {
        id: 13,
        fullname: "Juana Cathee",
        position: "Financial Controller",
        office: "Singapore",
        age: 27,
        start_date: "12/9/2022",
        salary: 1112882,
    },
    {
        id: 14,
        fullname: "Joann Lynnett",
        position: "Software Engineer",
        office: "Singapore",
        age: 37,
        start_date: "11/16/2022",
        salary: 578557,
    },
    {
        id: 15,
        fullname: "Randene Pering",
        position: "Secretary",
        office: "San Francisco",
        age: 30,
        start_date: "3/27/2022",
        salary: 657537,
    },
    {
        id: 16,
        fullname: "Blondelle Delacourt",
        position: "Post-Sales support",
        office: "Sydney",
        age: 30,
        start_date: "8/28/2022",
        salary: 335271,
    },
    {
        id: 17,
        fullname: "Giffie Airds",
        position: "Javascript Developer",
        office: "Sydney",
        age: 32,
        start_date: "8/10/2023",
        salary: 468982,
    },
    {
        id: 18,
        fullname: "Willie Ceeley",
        position: "Junior Javascript Developer",
        office: "New York",
        age: 31,
        start_date: "12/27/2022",
        salary: 892832,
    },
    {
        id: 19,
        fullname: "Shel Shimon",
        position: "Chief Executive Officer (CEO)",
        office: "Edinburgh",
        age: 44,
        start_date: "3/22/2022",
        salary: 131546,
    },
    {
        id: 20,
        fullname: "Dorothy Ballintyne",
        position: "Technical Author",
        office: "London",
        age: 45,
        start_date: "9/5/2022",
        salary: 1194808,
    },
    {
        id: 21,
        fullname: "Lauren Easterfield",
        position: "Personnel Lead",
        office: "San Francisco",
        age: 32,
        start_date: "9/13/2022",
        salary: 756288,
    },
    {
        id: 22,
        fullname: "Leola Lansdown",
        position: "Integration Specialist",
        office: "San Francisco",
        age: 35,
        start_date: "5/14/2023",
        salary: 1147570,
    },
    {
        id: 23,
        fullname: "Kelly Munden",
        position: "Development Lead",
        office: "Tokyo",
        age: 30,
        start_date: "10/20/2023",
        salary: 999209,
    },
    {
        id: 24,
        fullname: "Eduino Wallicker",
        position: "Systems Administrator",
        office: "Singapore",
        age: 36,
        start_date: "10/9/2022",
        salary: 1001551,
    },
    {
        id: 25,
        fullname: "Meghann McGeaney",
        position: "Marketing Designer",
        office: "San Francisco",
        age: 33,
        start_date: "4/7/2022",
        salary: 800334,
    },
    {
        id: 26,
        fullname: "Letta Attle",
        position: "Development Lead",
        office: "San Francisco",
        age: 31,
        start_date: "3/20/2023",
        salary: 284665,
    },
    {
        id: 27,
        fullname: "Micheline Sims",
        position: "Post-Sales support",
        office: "Sydney",
        age: 27,
        start_date: "12/20/2022",
        salary: 258793,
    },
    {
        id: 28,
        fullname: "Kathlin Hotson",
        position: "Javascript Developer",
        office: "London",
        age: 27,
        start_date: "7/7/2022",
        salary: 232500,
    },
    {
        id: 29,
        fullname: "Jesus Rix",
        position: "Customer Support",
        office: "Edinburgh",
        age: 29,
        start_date: "8/8/2022",
        salary: 1006803,
    },
    {
        id: 30,
        fullname: "Ambrosi Guinn",
        position: "Javascript Developer",
        office: "Singapore",
        age: 31,
        start_date: "10/7/2022",
        salary: 469066,
    },
    {
        id: 31,
        fullname: "Berti Iacobini",
        position: "Chief Executive Officer (CEO)",
        office: "San Francisco",
        age: 25,
        start_date: "12/18/2022",
        salary: 528593,
    },
    {
        id: 32,
        fullname: "Betteann Haining",
        position: "Technical Author",
        office: "London",
        age: 37,
        start_date: "6/19/2022",
        salary: 593229,
    },
    {
        id: 33,
        fullname: "Leandra Farrear",
        position: "Development Lead",
        office: "New York",
        age: 34,
        start_date: "6/13/2022",
        salary: 1116349,
    },
    {
        id: 34,
        fullname: "Lula Easterfield",
        position: "Junior Javascript Developer",
        office: "San Francisco",
        age: 30,
        start_date: "3/20/2022",
        salary: 1151059,
    },
    {
        id: 35,
        fullname: "Aldridge Polson",
        position: "Team Leader",
        office: "San Francisco",
        age: 35,
        start_date: "2/4/2022",
        salary: 1021492,
    },
    {
        id: 36,
        fullname: "Rozanne Isaksson",
        position: "Personnel Lead",
        office: "London",
        age: 34,
        start_date: "10/16/2023",
        salary: 1080544,
    },
    {
        id: 37,
        fullname: "Bentley Eagan",
        position: "Systems Administrator",
        office: "Sydney",
        age: 30,
        start_date: "8/22/2022",
        salary: 500284,
    },
    {
        id: 38,
        fullname: "Loree Donizeau",
        position: "Secretary",
        office: "London",
        age: 29,
        start_date: "2/26/2022",
        salary: 288083,
    },
    {
        id: 39,
        fullname: "Seymour Maskell",
        position: "Secretary",
        office: "Edinburgh",
        age: 37,
        start_date: "8/4/2022",
        salary: 270694,
    },
    {
        id: 40,
        fullname: "Morris Tretwell",
        position: "Customer Support",
        office: "Singapore",
        age: 32,
        start_date: "7/9/2022",
        salary: 279149,
    },
    {
        id: 41,
        fullname: "Claudie Ellwood",
        position: "Personnel Lead",
        office: "San Francisco",
        age: 33,
        start_date: "8/26/2022",
        salary: 812108,
    },
    {
        id: 42,
        fullname: "Miof mela Patching",
        position: "Accountant",
        office: "Tokyo",
        age: 42,
        start_date: "8/9/2022",
        salary: 390233,
    },
    {
        id: 43,
        fullname: "Jenelle McKane",
        position: "Personnel Lead",
        office: "Tokyo",
        age: 29,
        start_date: "5/16/2023",
        salary: 646720,
    },
    {
        id: 44,
        fullname: "Syd Sainsbury-Brown",
        position: "Customer Support",
        office: "London",
        age: 43,
        start_date: "9/3/2022",
        salary: 397054,
    },
    {
        id: 45,
        fullname: "Giff Chalk",
        position: "Marketing Designer",
        office: "San Francisco",
        age: 33,
        start_date: "10/2/2022",
        salary: 807862,
    },
    {
        id: 46,
        fullname: "Noellyn Folland",
        position: "Financial Controller",
        office: "Sydney",
        age: 28,
        start_date: "10/8/2022",
        salary: 164455,
    },
    {
        id: 47,
        fullname: "Laura Jenkerson",
        position: "Sales Assistant",
        office: "New York",
        age: 41,
        start_date: "10/16/2022",
        salary: 1015029,
    },
    {
        id: 48,
        fullname: "Chevy Porritt",
        position: "Technical Author",
        office: "Sydney",
        age: 18,
        start_date: "5/24/2022",
        salary: 1057849,
    },
    {
        id: 49,
        fullname: "Jessy Scarff",
        position: "Post-Sales support",
        office: "San Francisco",
        age: 35,
        start_date: "3/12/2022",
        salary: 317120,
    },
    {
        id: 50,
        fullname: "Wadsworth Mariaud",
        position: "Personnel Lead",
        office: "Singapore",
        age: 41,
        start_date: "3/6/2022",
        salary: 283367,
    }
];

export default EmployeeData;
